import React from 'react'
import AppLayout from "@/Layouts/AppLayout";
import {Container, Emma} from "@/Components";

export default function ErrorPage({status}) {
  const title = {
    503: 'Service Unavailable',
    500: 'Server Error',
    404: 'Page Not Found',
    403: 'Forbidden',
    400: 'Bad Request',
    410: 'Expired',
  }[status]

  const description = {
    503: 'Sorry, we are doing some maintenance. Please check back soon.',
    500: 'Whoops, something went wrong on our servers.',
    404: 'Sorry, the page you are looking for could not be found.',
    403: 'Sorry, you are forbidden from accessing this page.',
    400: 'Sorry, the page you are trying to reach cannot be accessed',
    410: 'Whoops, the page you are trying to reach have expired',
  }[status]

  return (
    <div className="relative z-0 w-full m-0 overflow-x-hidden bg-background">
      <Container>
        <div className="flex flex-col items-stretch">
          <div className="flex flex-row flex-shrink-0 my-4 mt-24">
            <div className="w-full sm:w-2/3">
              <h1 className="mb-4 header-1">{title}</h1>
              <p className="text-gray-700">{description}</p>
            </div>
            <Emma className="self-end flex-shrink hidden w-1/3 sm:block" color="red" tooltip="Sorry, something went wrong..." />
          </div>
        </div>
      </Container>
    </div>
  )
}

ErrorPage.layout = page => (
  <AppLayout title="Error">
    {page}
  </AppLayout>
)
